export const defaultRangeSubTitle = [
    {
        text: 'Use the ',
        code: '.react-range'
    },
    {
        text: ' to display range slider using react.'
    }
]

export const disabledSliderSubTitle = [
    {
        text: 'Use the ',
        code: '[disabled=true]'
    },
    {
        text: ' to display disabled range slider using react.'
    }
]

export const imageCropperSubTitle = [
    {text: 'Use the image react-image-crop'}
]